import { Sparkles } from 'lucide-react';
import { motion } from 'motion/react';
import { useTranslation } from 'react-i18next';

export function AILoadingAnimation() {
  const { t } = useTranslation();

  return (
    <div className='flex flex-col items-center justify-center py-12 space-y-4'>
      <div className='relative w-32 h-32 flex items-center justify-center'>
        {/* Main rotating icon */}
        <motion.div
          className='w-16 h-16 bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center shadow-lg'
          animate={{
            scale: [1, 1.1, 1],
            rotate: [0, 180, 360],
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        >
          <Sparkles className='w-8 h-8 text-white' />
        </motion.div>

        {/* Orbiting particles */}
        {[0, 1, 2].map((i) => (
          <motion.div
            key={i}
            className='absolute top-1/2 left-1/2 w-3 h-3 rounded-full'
            style={{
              background:
                i === 0
                  ? 'linear-gradient(135deg, #a855f7, #ec4899)'
                  : i === 1
                    ? 'linear-gradient(135deg, #ec4899, #f97316)'
                    : 'linear-gradient(135deg, #8b5cf6, #a855f7)',
            }}
            animate={{
              x: [0, 45 * Math.cos((i * 120 * Math.PI) / 180)],
              y: [0, 45 * Math.sin((i * 120 * Math.PI) / 180)],
              scale: [0, 1, 0],
              opacity: [0, 1, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 0.3,
              ease: 'easeOut',
            }}
          />
        ))}

        {/* Pulsing rings */}
        {[0, 1].map((i) => (
          <motion.div
            key={`ring-${i}`}
            className='absolute top-1/2 left-1/2 border-2 border-purple-400/30 rounded-full'
            style={{
              width: 80,
              height: 80,
              marginLeft: -40,
              marginTop: -40,
            }}
            animate={{
              scale: [1, 1.5],
              opacity: [0.5, 0],
            }}
            transition={{
              duration: 2,
              repeat: Infinity,
              delay: i * 1,
              ease: 'easeOut',
            }}
          />
        ))}
      </div>

      <div className='text-center space-y-3'>
        <motion.div
          className='font-medium'
          animate={{ opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 1.5, repeat: Infinity }}
        >
          {t('aiAutomation.analyzing')}
        </motion.div>
        <div className='text-sm text-muted-foreground'>
          {t('aiAutomation.creatingRules')}
        </div>
      </div>
    </div>
  );
}
